import React from "react";
import { useAuth } from "../../Store/AuthContext";
import { AboutFetchData } from "../../APIS/FetchAPIs";

export default function AboutSection2Home() {
  const { RendomTokenfetch } = useAuth();
  const [aboutData] = AboutFetchData(RendomTokenfetch);
  return (
    <>
      <section
        className="about-us-section about-us-section-style3 section-padding"
        style={{ backgroundImage: `url('images/propertie-bg.jpg')` }}
      >
        <div className="container">
          <div className="row section-title">
            <h2 className="section_margin_buttom_zero">
              {aboutData?.title2 || ""}
            </h2>
          </div>

          <div className="row content">
            <div className="col col-md-12">
              <div className="box">
                {aboutData?.about_tagline2 && (
                  <h3>{aboutData?.about_tagline2 || ""}</h3>
                )}
                <div
                  className=""
                  dangerouslySetInnerHTML={{
                    __html: aboutData.about_description2,
                  }}
                ></div>
              </div>
            </div>
            {aboutData.about_banner !== "" && (
              <div className="col col-md-12 about-company-slider-wrapper aboutsection2imgbox">
                <div className="about-company-slider">
                  <div>
                    {aboutData.about_banner !== "" ? (
                      <img
                        src={aboutData.about_banner}
                        alt={aboutData.aboutbanner_alt}
                        title={aboutData.aboutbanner_title}
                        className="img img-responsive"
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
}
